import { Primitive } from '../Primitive';
import { Type } from '../Type';
import { Point3D } from './Point3D';
export class Sphere extends Primitive {
    center;
    radius;
    constructor(center, radius) {
        super(Type.Sphere);
        let centerValue;
        switch (true) {
            case center instanceof Point3D:
                centerValue = center;
                break;
            case Array.isArray(center):
                center = center;
                centerValue = new Point3D(center[0], center[1], center[2]);
                break;
            default:
                center = center;
                centerValue = new Point3D(center.x, center.y, center.z);
        }
        this.center = centerValue;
        this.radius = radius;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3BoZXJlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi90eXBlcy9nZW9tZXRyeV8zZC9TcGhlcmUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGNBQWMsQ0FBQTtBQUN4QyxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sU0FBUyxDQUFBO0FBRTlCLE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSxXQUFXLENBQUE7QUFFbkMsTUFBTSxPQUFPLE1BQU8sU0FBUSxTQUFTO0lBQzFCLE1BQU0sQ0FBUztJQUNmLE1BQU0sQ0FBUTtJQUV2QixZQUNFLE1BRzRCLEVBQzVCLE1BQWM7UUFFZCxLQUFLLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFBO1FBRWxCLElBQUksV0FBb0IsQ0FBQTtRQUN4QixRQUFRLElBQUksRUFBRTtZQUNaLEtBQUssTUFBTSxZQUFZLE9BQU87Z0JBQzVCLFdBQVcsR0FBRyxNQUFpQixDQUFBO2dCQUMvQixNQUFLO1lBQ1AsS0FBSyxLQUFLLENBQUMsT0FBTyxDQUFDLE1BQU0sQ0FBQztnQkFDeEIsTUFBTSxHQUFHLE1BQWtDLENBQUE7Z0JBQzNDLFdBQVcsR0FBRyxJQUFJLE9BQU8sQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLEVBQUUsTUFBTSxDQUFDLENBQUMsQ0FBQyxFQUFFLE1BQU0sQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFBO2dCQUMxRCxNQUFLO1lBQ1A7Z0JBQ0UsTUFBTSxHQUFHLE1BQTZDLENBQUE7Z0JBQ3RELFdBQVcsR0FBRyxJQUFJLE9BQU8sQ0FBQyxNQUFNLENBQUMsQ0FBQyxFQUFFLE1BQU0sQ0FBQyxDQUFDLEVBQUUsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFBO1NBQzFEO1FBRUQsSUFBSSxDQUFDLE1BQU0sR0FBRyxXQUFXLENBQUE7UUFDekIsSUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUE7SUFDdEIsQ0FBQztDQUNGIn0=